import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M2 20h20v2H2v-2zM2 7l10-5 10 5v4H2V7zm2 1.24V9h16v-.76l-8-4-8 4zM12 8a1 1 0 110-2 1 1 0 010 2z"/>
    <path fill="#34CEFF" d="M6 12H4v7h2v-7zM11 12H9v7h2v-7zM15 12h-2v7h2v-7zM20 12h-2v7h2v-7z"/>
  </SvgIcon>
);